import React from 'react';
import { SectionFade } from './ui/SectionFade';
import { Button } from './ui/Button';
import { ShieldIcon, DownloadIcon } from 'lucide-react';
export function FinalCTA() {
  return <section id="pricing" className="py-32 px-4 bg-brand-black relative overflow-hidden border-t border-brand-neon/30" data-id="element-56">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(200,255,0,0.1)_0%,transparent_60%)] pointer-events-none" data-id="element-57"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-58">
        <SectionFade data-id="element-59">
          <h2 className="font-bebas text-5xl md:text-7xl mb-6 tracking-tight" data-id="element-60">
            ADQUIERE "ETIQUETAS SIN MENTIRAS" POR SOLO
          </h2>
        </SectionFade>

        <SectionFade delay={0.1} data-id="element-61">
          <div className="mb-8" data-id="element-62">
            <span className="text-4xl md:text-6xl font-bebas text-gray-500 line-through mr-4" data-id="element-63">
              $15
            </span>
            <div className="text-8xl md:text-[10rem] font-bebas text-brand-neon leading-none drop-shadow-[0_0_20px_rgba(200,255,0,0.3)]" data-id="element-64">
              $6.36 <span className="text-5xl md:text-7xl" data-id="element-65">USD</span>
            </div>
          </div>
        </SectionFade>

        <SectionFade delay={0.2} data-id="element-66">
          <p className="text-xl md:text-3xl font-inter font-light text-white mb-12" data-id="element-67">
            Acceso inmediato. Un solo pago. <br className="hidden md:block" data-id="element-68" />
            <strong className="font-semibold text-brand-neon" data-id="element-69">
              Poder de decisión para toda la vida.
            </strong>
          </p>
        </SectionFade>

        <SectionFade delay={0.3} data-id="element-70">
          <div className="flex flex-col items-center gap-6" data-id="element-71">
            <Button href="https://guias-salud.com/cart/46190329495740:1" className="w-full md:w-auto text-xl md:text-3xl py-6 px-12" data-id="element-72">
              QUIERO DEJAR DE SER ENGAÑADO AHORA
            </Button>

            <div className="flex flex-col md:flex-row items-center gap-6 text-gray-400 font-inter text-sm md:text-base mt-4" data-id="element-73">
              <div className="flex items-center gap-2" data-id="element-74">
                <ShieldIcon size={20} className="text-brand-neon" data-id="element-75" />
                <span data-id="element-76">Compra segura</span>
              </div>
              <div className="hidden md:block w-1 h-1 rounded-full bg-gray-600" data-id="element-77"></div>
              <div className="flex items-center gap-2" data-id="element-78">
                <DownloadIcon size={20} className="text-brand-neon" data-id="element-79" />
                <span data-id="element-80">Descarga instantánea en PDF</span>
              </div>
            </div>
          </div>
        </SectionFade>
      </div>
    </section>;
}